const getJournalistFirstName = (opportunity) => {
  if (!opportunity?.journalist) {
    return '<span class="highlight">Journalist name</span>';
  }
  return opportunity.journalist.split(' ')[0];
};

export default getJournalistFirstName;
